module.exports = __webpack_public_path__ + "imgs/twitter2.536733a8f1974014b3d692775d3069fd.svg";